document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("click", function (e) {
    const icon = e.target.closest(".copy-icon");
    if (!icon) return;

    const code = icon.dataset.copy;

    navigator.clipboard.writeText(code).then(() => {
      icon.classList.add("copied");

      setTimeout(() => {
        icon.classList.remove("copied");
      }, 3000);
    });
  });
});